import { useMemo } from 'react'
import { useGetRollersQuery } from '../store/api/rollers-api'
import Roller from '../types/api/roller'

export type RollerVariant = {
    distance: number
    numberOfLabels: number
    roller: Roller
}

export function useRollerVariants(length: number | undefined | null) {
    const { data } = useGetRollersQuery({
        populate: { machines: { populate: { machine_brand: true } } },
        pagination: { pageSize: 100, page: 1 },
    })
    const rollers = data?.data ?? []

    return useMemo(() => {
        const l = length ?? 1
        const list: RollerVariant[] = []

        rollers.forEach(r => {
            let maxOfLabels = Math.floor(r.roller / l)
            let numberOfLabels = maxOfLabels
            for (let j = 1; j <= 4 && numberOfLabels !== 1; j++) {
                const distance = (r.roller - numberOfLabels * l) / numberOfLabels
                list.push({ distance, numberOfLabels, roller: r })
                numberOfLabels -= 1
            }
        })

        return list.sort((a, b) => a.distance - b.distance)
    }, [rollers, length])
}

/** Варианты валов с добавлением в начало по одному варианту с distance = 0 на каждый вал. */
export function useRollerVariantsWithZeroFirst(length: number | undefined | null) {
    const variants = useRollerVariants(length)

    return useMemo(() => {
        const l = length ?? 1
        const hasZeroByRollerId = new Set(
            variants.filter(v => v.distance === 0).map(v => v.roller.id)
        )
        const seenRollerIds = new Set<number>()
        const zeroFirst: RollerVariant[] = []

        variants.forEach(v => {
            if (seenRollerIds.has(v.roller.id)) return
            seenRollerIds.add(v.roller.id)
            if (!hasZeroByRollerId.has(v.roller.id)) {
                const numberOfLabels = v.roller.roller / l
                zeroFirst.push({
                    distance: 0,
                    numberOfLabels: Math.round(numberOfLabels * 10) / 10,
                    roller: v.roller,
                })
            }
        })

        return [...zeroFirst.sort((a, b) => a.roller.roller - b.roller.roller), ...variants]
    }, [variants, length])
}
